export function getUniqueStrings(array: string[]): string[] {
    return Array.from(new Set(array));
  }
  